module.exports = __webpack_public_path__ + "static/img/coupon.bcf21863.png";